import React, { useEffect, useState } from "react";
import DisplayPred from "./components/displaypred/DisplayPred.jsx";
import MainPage from "./pages/main/index.js";
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
import store from "./slices";
import "./App.css";

function App() {
  return (
    <Provider store={store}>
      <div>
        <Helmet>
          <title>Canada Goose Authenticator</title>
          <meta
            name="description"
            content="An tool for authenticating Canada Goose Badges"
          />
          <meta
            name="keywords"
            content="Canada Goose, CandaGoose, CandaGoose Authenticator, Real, Fake"
          />
        </Helmet>
        <MainPage />
      </div>
    </Provider>
  );
}

export default App;
